import React, { useEffect, useState } from "react";
import UserWrapper from "./form.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import FormServices from "../../api/FormServices";
import EncryptDecrypt from "../../api/EncryptDecrypt";
import FormForm from "components/form/FormForm";

const FormEdit = props => {
  const [editedData, setEditedData] = useState(undefined);
  const hasParam = props.match.params.id;
  useEffect(() => {
    if (hasParam) {
      const params = {
        form_id: hasParam
      };
      FormServices.view(params).then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        setEditedData(data.data);
      });
    }
  }, []);

  const submitFormHandler = (data, action) => {
    setTimeout(() => {
      props.history.push("/form");
    }, 2000);
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.formManagement"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.formManagement",
              url: "/form"
            },
            {
              name: hasParam ? "action.edit" : "action.add"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/form")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> {hasParam ? "Edit" : "Add"} Form
            </div>
          </div>
          <div className="roe-card-body">
            <FormForm
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
              {...props}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    authData: {
      adminRoleId: state.auth.admin_role_id,
      adminRole: state.auth.admin_role,
      service_id: state.auth.service_id
    }
  };
};

export default connect(mapStateToProps, null)(FormEdit);
